'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	icon: 'M13 0H3C1 0 0 1 0 3v10c0 2 1 3 3 3h5V9H6V7h2V5c0-2 2-2 2-2h3v2h-3v2h3l-.5 2H10v7h3c2 0 3-1 3-3V3c0-2-1-3-3-3z',
	popupUrl: 'https://www.facebook.com/sharer/sharer.php?u={url}',
	popupWidth: 600,
	popupHeight: 500
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/social-likes-next/lib/services/facebook.js
// module id = 24
// module chunks = 0